module.exports = __webpack_public_path__ + "01_glasses_black.e66021d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/01_glasses_black.png
// module id = EiBn
// module chunks = 0